<template src="./App.html"></template>

<script>
import Navbar from './components/partials/views/Navbar.vue'
import Subnavbar from './components/partials/views/Subnavbar.vue'
import LeftSidebar from './components/partials/views/LeftSidebar.vue'
import Foot from './components/partials/views/Foot.vue'
import Breadcrumb from './components/partials/views/Breadcrumb.vue'
import swal from 'sweetalert2'
import VueElementLoading from 'vue-element-loading'

export default {
	components: {
		'navbar': Navbar,
		'subnavbar': Subnavbar,
		'leftsidebar': LeftSidebar,
		'foot': Foot,
		'breadcrumb': Breadcrumb,
		'loading': VueElementLoading,
	},
	data () {
		return {
			user: null,
			isAuth: false,
			menus: [],
			loading: true,

			authentication: false,
		}
	},
	watch: {
		$route() {
			this.activeMenu()
			this.closeAllModals()
		}
	},
	created() {
		this.init()
	},
	methods: {
		init() {
			this.isAuthentication()
			this.getLocale()
			this.getUser()
			this.setCurrencyConfig()
		},
		getLocale() {
			if(!this.$lang.getLang()) {
				this.$http.get('locale')
				.then(response => {
					this.$lang.setLang(response.body)
					this.$i18n.locale = this.$lang.getLang()
					this.setLang()
				}, function(error) {
					console.log(error)
				})
			} else {
				this.$i18n.locale = this.$lang.getLang()
			}
			this.setLang()
		},
		setLang() {
			document.querySelector('html').setAttribute('lang', this.$lang.getLang())
		},
		getUser() {
			this.token = this.$auth.getToken()
			if(this.token) {
				this.$http.get('user')
				.then(response => {
					this.loading = false
					this.user = response.body
					this.isAuth = true
					this.$set(this.user, 'hasRole', this.hasRole)
					this.$set(this.user, 'hasPackage', this.hasPackage)
					this.loadMenus()
					//this.setExpired()
				}, function(error) {
					console.log(error)
					if(error.status == 404) {
						if(!this.$route.meta.public) {
							this.$router.push('/' + this.$i18n.locale + "/" + this.$platform.slug)
							location.reload()

						}
					}
					this.loading = false
				})
			} else {
				this.loading = false
			}
		},
		hasRole(role, requireAll = false) {
			if(this.user) {
				if(this.user.roles) {
					var roles = this.user.roles.filter(function(element) {
						if(Array.isArray(role)) {
							return role.find(function(rol) {
								if(element.name == rol) return true
							})
						} else {
							if(element.name == role) return true
						}
					})
					if(Array.isArray(role)) {
						if(requireAll) {
							if(role.length != roles.length) {
								return false
							}
						}
					}
					if(roles.length) return true
				}
			}
			return false
		},
		hasPackage(id, requireAll = false) {
			if(this.user) {
				if(this.user.platform) {
					if(this.user.platform.accounts) {
						var accounts = this.user.platform.accounts.filter(function(account) {
							if(Array.isArray(id)) {
								if(account.package) {
									return id.find(function(package_id) {
										if(account.id == package_id) return true
									})
								}
							} else {
								if(account.package) {
									if(account.package.id == id) return true
								}
							}
						})
						if(Array.isArray(id)) {
							if(requireAll) {
								if(accounts.length != id.length) {
									return false
								}
							}
						}
						if(accounts.length) return true
					}
				}
			}
			return false
		},
		reload() {
			this.init()
		},
		menuSelected(menu) {
			this.menus.forEach(function(element) {
				if(menu.slug == element.slug) {
					element.active = true
				} else {
					element.active = false
				}
			})
		},
		loadMenus() {
			var menus = []
			var that = this
			if(this.$platform) {
				if(this.$platform.accounts) {
					this.$platform.accounts.forEach(function(account) {
						if(account.status_id == 2) {
							if(account.package.id == 1) {
								var slug = 'cms'
								var icon = '<i aria-hidden="true" class="fa fa-file-text-o"></i>'
							}

							if(account.package.id == 2) {
								var slug = 'management'
								var icon = '<i aria-hidden="true" class="fa fa-clipboard"></i>'
							}

							if(account.package.id == 3) {
								var slug = 'projects'
								var icon = '<i data-icon="v" class="ti-folder"></i>'
							}

							var menu = {
								active: false,
								package: account.package,
								plan: account.plan,
								slug: slug,
								icon: icon,
							}

							if(menu) {
								menus.push(menu)
							}
						}
					})
				}
			}
			this.menus = menus
			this.activeMenu()
		},
		activeMenu() {
			var menu_slug = null
			if(this.$route) {
				if(this.$route.meta) {
					if(this.$route.meta.menu) {
						menu_slug = this.$route.meta.menu
					}
				}
			}

			if(menu_slug) {
				this.menus.forEach(function(menu) {
					if(menu.slug == menu_slug) {
						menu.active = true
					} else {
						menu.active = false
					}
				})
			} else {
				if(this.menus.length) {
					this.menus[0].active = true
				}
			}
		},
		isAuthentication() {
			if(this.$route) {
				if(this.$route.meta) {
					if(this.$route.meta.authentication) {
						this.authentication = this.$route.meta.authentication
					}
				}
			}
		},
		setExpired() {
			var expiration = parseInt(localStorage.getItem('expiration'))
			var now = Date.now()
			var duration = expiration - now
			var that = this
			setInterval(() => {
				console.log(moment().toString())
				console.log('expired...')
			}, duration)
		},
		setCurrencyConfig() {
			if(this.$platform) {
				if(this.$platform.setting) {
					if(this.$platform.setting.currency) {
						this.$CurrencyFilter.setConfig({
							symbol: this.$platform.setting.currency.symbol,
							thousandsSeparator: this.$platform.setting.currency.thousands,
							fractionCount: this.$platform.setting.currency.precision,
							fractionSeparator: this.$platform.setting.currency.decimal,
							symbolPosition: this.$platform.setting.currency.symbol_position,
							symbolSpacing: this.$platform.setting.currency.symbol_spacing,
						})
					}
				}
			}
		},
		closeAllModals() {
			$('.modal').modal('hide')
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/App.vue